<template>
  <div class="rule-content" v-show="isShow">
    <div
      class="content"
      :style="{'background-image': `url(${$lg(config, 'season_rule', '')})`, transform: `scale(${scale})`}"
      @click="hideModal()"
    >
      <div class="close"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  inject: ['json_config'],
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState(['scale']),
    config() {
      return this.json_config()
    }
  },
  methods: {
    showModal() {
      this.isShow = true
    },
    hideModal() {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
  .content {
    position: absolute;
    width: 1286px;
    height: 724px;
    top: 50%;
    left: 50%;
    margin-left: -0.5 * 1286px;
    margin-top: -0.5 * 724px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    .close {
      background-image: $icon_close;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 51px;
      height: 28px;
      position: absolute;
      top: 0;
      right: -50px;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;
    }
  }
}
</style>